import { Trans } from 'react-i18next'

import SectionProgress from '~/pages/anatomyV2/libs/components/SectionProgress'
import {
  greenAccept,
  redCross,
} from '~/pages/anatomyV2/libs/components/TrueFalseQuestionTemplate/constants'
import { TrueFalseQuestionTemplateStyles as S } from '~/pages/anatomyV2/libs/components/TrueFalseQuestionTemplate/styles'
import { useMatchHeaderBackground } from '~/pages/anatomyV2/libs/hooks/useMatchHeaderBackground'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

interface ITrueFalseQuestionTemplateProps extends TPageProps {
  currentSection: number
  titleI18nKey: string
  factI18nKey: string
  questionImagePNG: string
  questionImageWEBP: string
  questionImageAlt: string
  question: string
  cardBackground?: string
  firstBehindColor?: string
  secondBehindColor?: string
}

const TrueFalseQuestionTemplate = ({
  pageId,
  nextPagePath,
  currentSection,
  titleI18nKey,
  factI18nKey,
  questionImagePNG,
  questionImageWEBP,
  questionImageAlt,
  question,
  cardBackground,
  firstBehindColor,
  secondBehindColor,
}: ITrueFalseQuestionTemplateProps) => {
  useMatchHeaderBackground()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <SectionProgress currentSection={currentSection} pageId={pageId} />

        <S.Title>
          <Trans ns="anatomyV2" i18nKey={titleI18nKey} />
        </S.Title>

        <S.CardWrapper
          $firstBehindColor={firstBehindColor}
          $secondBehindColor={secondBehindColor}
        >
          <S.Card $background={cardBackground}>
            <S.CardImage>
              <picture>
                <source srcSet={questionImageWEBP} type="image/webp" />
                <img src={questionImagePNG} alt={questionImageAlt} />
              </picture>
            </S.CardImage>

            <S.CardFact>
              <Trans ns="anatomyV2" i18nKey={factI18nKey} />
            </S.CardFact>
          </S.Card>
        </S.CardWrapper>

        <S.AnswerRow>
          <S.AnswerButton type="button" onClick={() => handleContinue('false')}>
            <S.AnswerIcon src={redCross} alt="false" />
            <Trans ns="anatomyV2" i18nKey="onboarding.trueFalse.false" />
          </S.AnswerButton>

          <S.AnswerButton type="button" onClick={() => handleContinue('true')}>
            <S.AnswerIcon src={greenAccept} alt="true" />
            <Trans ns="anatomyV2" i18nKey="onboarding.trueFalse.true" />
          </S.AnswerButton>
        </S.AnswerRow>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default TrueFalseQuestionTemplate
